export const REGULAR_TRANSLATIONS = {
  change: 'REGULAR.CHANGE',
  email: 'REGULAR.EMAIL',
  cardNumber: 'REGULAR.METRO_CARD_NUMBER',
  password: 'REGULAR.PASSWORD',
  save: 'REGULAR.SAVE',
};

